import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "15", y1: "3", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 9 3 3-3 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PanelRightClose";
const PanelRightClose = memo(themed(Icon));
export {
  PanelRightClose
};
//# sourceMappingURL=panel-right-close.js.map
